<style scoped lang="scss">

</style>
<template>
    <el-dialog
        title="添加医生"
        :append-to-body="true"
        :visible.sync="showTag"
        width="40%">
        <div>
            <div class="pb10">
                <el-input
                    size="mini"
                    placeholder="请输入关键词"
                    v-model="key">
                    <el-button slot="append" icon="el-icon-search" @click="getList"></el-button>
                </el-input>
            </div>
            <el-table :data="list" size="mini" border style="width: 100%">
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column prop="docName" width="200px" label="医生姓名"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="{row}">
                        <el-button type="text" @click="add(row)">选择</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="showTag = false" size="mini">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
  import {systemService} from "../../../common/lib/service/system";
  import {staffService} from "../service/staff";

  export default {
    name: "add-doc-dialog",
    data() {
      return {
        showTag: false,
        key: '',
        docType: '', emergencyPersonnelId: '',
        page: {},
        list: []
      }
    },
    computed: {},
    created() {
    },
    methods: {
      show(docType, emergencyPersonnelId) {
        this.emergencyPersonnelId = emergencyPersonnelId;
        this.docType = docType;
        this.showTag = true;
      },
      hide() {
        this.emergencyPersonnelId = '';
        this.showTag = false;
      },
      async getList() {
        const {list} = await systemService.listDoc({
          docType: this.docType,
          searchString: this.key,
          hosId: this.loginInfo.hosId
        });
        this.list = list;
      },
      async add(data) {
        if (this.emergencyPersonnelId) {
          if (await staffService.modifyDoc(this.emergencyPersonnelId, data.docId)) {
            this.$message.success('修改成功');
            this.$emit('ok', 1);
            this.hide();
          }
          return
        }
        if (await staffService.addDoc(data.docId)) {
          this.$message.success('添加成功');
          this.$emit('ok', 1);
          this.hide();
        }
      }
    },
  }
</script>
